import Actions                  from 'Redux/Actions';
import { LocationRepository }   from 'Domain/Repositories';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { message }              from 'antd';

export const updateLocationEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.updateLocationRequest.type),
    mergeMap(action => from(LocationRepository.update(action.payload.id, action.payload.formData))
      .pipe(
        mergeMap((location) => {
          message.success('Die Speicherung des Locations erfolgreich.');

          return from([
            Actions.updateLocationSuccess({ location }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.updateLocationFailure({ error })
          ]);
        })
      )
    ),
  );
};
